import React, { useMemo, useCallback } from "react";
import ModulePreview from "../ModulePreview";

export default React.memo(() => {
	const defaultCustomPostData = useMemo(
		() => ({
			custom_post: {
				heading: "Your heading goes here",
				text: "Subtext can go here",
				photo_url:
					"https://coopcommerce.s3-us-west-1.amazonaws.com/user_new.png",
				dismiss_text: "I understand!",
			},
		}),
		[]
	);

	const customPostDataMapper = useCallback(
		(requestData, initData) => ({
			...(requestData?.custom_post
				? requestData.custom_post
				: initData.custom_post),
		}),
		[]
	);

	return (
		<ModulePreview
			moduleType="custom_post"
			remoteKey="custom_post"
			defaultData={defaultCustomPostData}
			moduleDataMapper={customPostDataMapper}
		/>
	);
});
